//定义路由规则
export const routes = [
    { path: '/', component: () => import('@/views/Home.vue'), name: 'Home' },
    { path: '/register', component: () => import('@/views/UserRegister.vue'), name: 'Register' },
    { path: '/login', component: () => import('@/views/UserLogin.vue'), name: 'Login' },
    { path: '/create-service', component: () => import('@/views/ServiceCreate.vue'), name: 'CreateService' },
    { path: '/services', component: () => import('@/views/ServiceList.vue'), name: 'ServiceList' },
    { path: '/create-order', component: () => import('@/views/OrderCreate.vue'), name: 'CreateOrder' },
    { path: '/orders', component: () => import('@/views/OrderList.vue'), name: 'OrderList' },
    { path: '/order/status', component: () => import('@/views/OrderStatus.vue'), name: 'OrderStatus' },
  ];